import React, { useEffect, useState } from 'react';
import { Form, Spinner, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlans } from '../../redux/slice/subscriptionSlice';
import { assignUserPlan, fetchUserDetail } from '../../redux/slice/allUsersSlice';
import CommonButton from "../../components/commonButton";
import withModal from '../withModal';
import ConfirmModal from '../withModal/ConfirmModal';
import { useToast } from '../../context/TostContext';
import CustomSelect from '../form/CustomSelect';

const AssignPlanModalInner = ({ onClose, userId }) => {
    const dispatch = useDispatch();
    const { plans, loading: plansLoading } = useSelector((state) => state.subscription);
    const [selectedPlan, setSelectedPlan] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const toast = useToast();
    useEffect(() => {
        dispatch(fetchPlans({ search: "", page: 1, limit: 100 }));
        setSelectedPlan("");
    }, [dispatch]);

    const activePlans = (plans || []).filter(plan => plan.status === 'active' && plan.plan_type !== 'free');

    const planOptions = activePlans.map(plan => ({
        value: plan.id,
        label: `${plan.name} - ₹${plan.price} (${plan.interval_count} ${plan.interval})`
    }));

    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        if (!selectedPlan) {
            toast.error("Please select a plan to assign.");
            return;
        }

        setShowConfirm(true);
    };

    const handleConfirmAssign = async () => {
        setIsSubmitting(true);
        try {
            await dispatch(assignUserPlan({ user_id: userId, plan_id: selectedPlan })).unwrap();
            toast.success("Plan assigned successfully!");
            onClose();
            // Refresh user details to update the UI instantly
            dispatch(fetchUserDetail(userId));
        } catch (error) {
            toast.error(error?.message || "Failed to assign plan.");
        } finally {
            setIsSubmitting(false);
            setShowConfirm(false);
        }
    };

    return (<> <Modal.Body>


        {plansLoading ? (
            <div className="d-flex align-items-center gap-2 text-muted mt-2">
                <Spinner animation="border" size="sm" />
                <span>Loading plans...</span>
            </div>
        ) : (

            <CustomSelect
                className="mt-2"
                options={planOptions}
                value={planOptions.find(opt => opt.value === selectedPlan)}
                onChange={(option) => setSelectedPlan(option ? option.value : "")}
                placeholder="Search Plan"
                isClearable
                label={{ name: "Select Plan" }}
            />

        )}
        {activePlans.length === 0 && !plansLoading && (
            <Form.Text className="text-danger">
                No active paid plans available.
            </Form.Text>
        )}
    </Modal.Body>
        <Modal.Footer>
            <CommonButton
                title={isSubmitting ? "Assigning..." : "Assign Plan"}
                onClick={handleSubmit}
                disabled={isSubmitting || !selectedPlan || activePlans.length === 0}
            />
        </Modal.Footer>
        <ConfirmModal
            isOpen={showConfirm}
            onClose={() => setShowConfirm(false)}
            title="Assign Plan Confirmation"
            message="Are you sure you want to assign this plan to the user?"
            onConfirm={handleConfirmAssign}
            className='confirm-modal'
        />
    </>

    );
};

const AssignPlanModal = withModal(AssignPlanModalInner);

export default AssignPlanModal;
